import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      meta:{title:'首页',keepAlive: false},
      component: () => import( './views/Index.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta:{title:'登录',keepAlive: false},
      component: () => import( './views/Login.vue')
    },
    {
      path: '/regInstitution',
      name: 'regInstitution',
      meta:{title:'注册机构',keepAlive: false},
      component: () => import( './views/RegInstitution.vue')
    },
    // {
    //   path: '/Hengfeng',
    //   name: 'hengfeng',
    //   meta:{title:'横峰县医学影像共享平台',keepAlive: true},
    //   component: () => import( './views/Hengfeng.vue')
    // },
    {
      path: '/hosIndex',
      name: 'hosIndex',
      meta:{title:'医院首页',keepAlive: false},
      component: () => import( './views/HosIndex.vue')
    },
    {
      path: '/docIndex',
      name: 'docIndex',
      meta:{title:'医生首页',keepAlive: false},

      component: () => import( './views/DocIndex.vue')
    },
    {
      path: '/platformTotal',
      name: 'platformTotal',
      meta:{title:'平台总数',keepAlive: false},

      component: () => import( './views/PlatformTotal.vue')
    },
	{
	  path: '/totalUploadList',
	  name: 'totalUploadList',
	  meta:{title:'平台总数',keepAlive: false},
	
	  component: () => import( './views/TotalUploadList.vue')
	},
    {
      path: '/platformAdd',
      name: 'platformAdd',
      meta:{title:'今日新增会诊',keepAlive: false},

      component: () => import( './views/PlatformAdd.vue')
    },
    {
      path: '/expertsOnline',
      name: 'expertsOnline',
      meta:{title:'在线专家',keepAlive: false},

      component: () => import( './views/ExpertsOnline.vue')
    },
    {
      path: '/expertsRegi',
      name: 'expertsRegi',
      meta:{title:'注册专家',keepAlive: false},

      component: () => import( './views/ExpertsRegi.vue')
    },
    {
      path: '/mechanismdetail',
      name: 'mechanismdetail',
      meta:{title:'机构详情',keepAlive: false},
      
      component: () => import( './views/mechanismdetail.vue')
    },
  ],
  scrollBehavior (to, from, savedPosition) {//处理滚动
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
       from.meta.savedPosition = document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})
